<ui-icon name="arrow-left" [size]="iconSize" [clickable]="true" (clicked)="onGoBack()"
  ><ng-content></ng-content>
</ui-icon>
